import React, { Component, PropTypes } from 'react';
import * as withdraw from './../payment/withdraw/withdraw-controller.js';
import accountInfo from '../account-info.js';
import notifications from '../notifications.js';

class Withdraw extends Component {
	componentWillMount() {
		withdraw.init(this.props.pathname, 'js-withdrawal-flow', '/casino');
		withdraw.withdrawFlow();

		/* withdraw.withdrawFlow()
			.then(flowDone => {
				withdraw.cleanup();
			}).error()
			*/

		document.documentElement.classList.add('overlay--open');
	}

	componentWillUnmount() {
		withdraw.cleanup();

		document.documentElement.classList.remove('overlay--open');
	}

	render() {
		return (
			<div id="withdraw" />
		);
	}
}

Withdraw.propTypes = {
	pathname: PropTypes.string
};

export default Withdraw;



// WEBPACK FOOTER //
// ./mobile-core/src/components/withdraw.js